import { useEffect, useState } from "react";
import type { Editor as EditorCore } from "@tiptap/react";

import { ITagResponse } from "@interfaces/responses.interface";
import { RelatedItem } from "@app-types/related-items.type";
import { TagsTypes } from "@components/Sections/TagsSection/constants";
import { BaseSpotlight } from "./BaseSpotlight";

export type ISpotlightProps = {
  editor: EditorCore;
  selectedTags: ITagResponse[];
  keyForTypes: keyof typeof TagsTypes;
};

export function Spotlight({ editor, selectedTags, keyForTypes }: ISpotlightProps) {
  const [query, setQuery] = useState("");
  const [showSpotlight, setShowSpotlight] = useState(false);

  useEffect(() => {
    if (!editor) return;

    const handleOpenSpotlight = () => {
      setShowSpotlight(true);
    };

    const handleCloseSpotlight = () => {
      setShowSpotlight(false);
      setQuery("");
    };

    editor.on("openSpotlight", handleOpenSpotlight);
    editor.on("closeSpotlight", handleCloseSpotlight);

    return () => {
      editor.off("openSpotlight", handleOpenSpotlight);
      editor.off("closeSpotlight", handleCloseSpotlight);
    };
  }, [editor]);

  const handleClose = (mention?: RelatedItem) => {
    if (!editor) return;

    if (mention) editor.commands.setMention(mention);

    setShowSpotlight(false);
    setQuery("");
  };

  return (
    <BaseSpotlight
      visible={showSpotlight}
      onClose={handleClose}
      query={query}
      onChange={setQuery}
      selectedTags={selectedTags}
      keyForTypes={keyForTypes}
    />
  );
}
